import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { useFetchCampaign } from '../../hooks/useFetchCampaign';
import MockProgressBar from './MockProgressBar.jsx';
import { Posts } from './Posts.jsx';
import { AudienceFilter } from './AudienceFilter.jsx';
import { Navbar } from '../Shared/Navbar.jsx';

import WelcomeBanner from '../../../../shared/WelcomeBanner/index.jsx';
import LoadingComponent from '../../../../shared/LoadingComponent/LoadingComponent.jsx';

import { setAudienceFilter } from '../../../../lib/redux/campaignPreview/campaignPreviewSlice';

export const Preview = ({ id }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const audienceFilter = useSelector(
    state => state.campaignPreview.audienceFilter,
  );
  const scrollPosition = useSelector(state => state.campaignScroll.preview);
  const { campaign, isFetching } = useFetchCampaign({
    id,
    forceRefetch: true,
    scrollPosition,
    page: 'preview',
  });
  const { color, welcomeMessage, name, posts, audiences } = campaign;
  const postsWithDates = posts.filter(post => post.publishDate !== null);
  const postsByAudience = postsWithDates.filter(post =>
    post.tiles.some(
      tile => tile.audienceId === audienceFilter || tile.audienceId === null,
    ),
  );
  const postsToShow =
    audienceFilter === 'all' ? postsWithDates : postsByAudience;

  const isInPlanPage = window.location.pathname.includes('/plan');
  const prefix = isInPlanPage ? '/campaigns' : '';

  const openFirstTile = () => {
    const firstPostWithTiles = postsToShow.find(p => p.tiles.length);

    if (!firstPostWithTiles) return;

    history.push(
      `${prefix}/${id}/tile/${firstPostWithTiles.tiles[0].id}?preview=true`,
    );
  };

  const dispatchAudienceFilter = audience => {
    dispatch(setAudienceFilter(audience));
  };

  if (isFetching) return <LoadingComponent />;

  return (
    <>
      <Navbar id={id}>
        <AudienceFilter
          audiences={audiences}
          audienceFilter={audienceFilter}
          setAudienceFilter={dispatchAudienceFilter}
        />
      </Navbar>
      <WelcomeBanner
        introMessage={welcomeMessage}
        primaryColor={color}
        name={name}
        handleOnClick={openFirstTile}
      />
      <Container>
        <MockProgressBar color={color} />
        <Posts id={id} posts={postsToShow} audienceFilter={audienceFilter} />
      </Container>
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  width: 828px;
`;
